import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useParams } from 'react-router';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';
import CompaniesForm from './CompaniesForm';

const page = `${Page['companies']}`;

const CompaniesNewPage = () => {
  const { accountId, domainId } = useParams();

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/companies`}>{page}</Anchor>
        <Text>New</Text>
      </Breadcrumbs>

      <Grid>
        <Grid.Col>
          <Card withBorder>
            <Card.Section inheritPadding py="sm">
              <CompaniesForm />
            </Card.Section>
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default CompaniesNewPage;
